export default __webpack_public_path__ + "static/media/dashboard-new-folio-icon.4724ea4d.svg";